<template>
  <div class="step__body">
    <div v-for="item in groups" :key="item.id" class="option option-walls">
      <div class="option-walls__left">
        <div class="option__name">{{ item.name }}</div>
        <div class="option__controls">
          <div v-for="option in item.options" :key="option.id" class="form-check">
            <input class="form-check-input" type="checkbox" value="" v-model="option.selected" :id="`custom-check${option.id}`" @click="onClickOption(option)">
            <label class="form-check-label" :class="{ 'disabled': option.disabled }" :for="`custom-check${option.id}`">
              {{ option.name }}
              <span v-if="effectiveDiscount(option) > 0" class="badge-sale ms-1">{{ effectiveDiscount(option) }}%</span>
              <template v-if="option.price.total > 0">
                <span v-if="effectiveDiscount(option) > 0" class="option__controls-price">
                  <span class="option__price--discount">{{ $filters.currency(option.price.discounted) }}</span>
                  <span class="option__price--old ms-1">{{ $filters.currency(option.price.total) }}</span>
                </span>
                <span v-else class="option__controls-price">{{ $filters.currency(option.price.total) }}</span>
              </template>
              <template v-else>
                <span v-if="effectiveDiscount(option) > 0" class="option__controls-price">
                  <span class="option__price--discount">{{ $filters.currency(discountedSelfPrice(option)) }}<span>m2</span></span>
                  <span class="option__price--old ms-1">{{ $filters.currency(option.price.self) }}<span>m2</span></span>
                </span>
                <span v-else class="option__controls-price">{{ $filters.currency(option.price.self) }}<span>m2</span></span>
              </template>
            </label>
          </div>
        </div>
        <a v-if="item.pdf_link" :href="item.pdf_link" class="download-link mt-3"><i class="fas fa-file-pdf me-2"></i>Technische Infos als PDF</a>
      </div>
      <div class="option-walls__right">
        <div class="tooltip-box text-end">
          <tooltip-btn :tooltip="item.tooltip"/>
        </div>
        <img :src="$filters.image(item.image, '190x')" alt="" class="img-fluid">
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import TooltipBtn from '@/pages/configurator/common/tooltipBtn.vue'
export default {
  components: { TooltipBtn },
  setup () {
    const store = useStore()
    const options = computed(() => {
      return store.getters['configurator/currentOptions']
    })
    const step = computed(() => {
      return store.getters['configurator/currentStep']
    })
    const checkOptionsGroup = computed(() => {
      const opts = options.value.filter(o => o.group === 'screen' || o.group === 'glass')
      if (opts.length > 0) {
        return true
      } else {
        return false
      }
    })
    const groups = computed(() => {
      const cats = step.value.cats
      const options = step.value.options
      const arr = []
      cats.forEach(cat => {
        const items = options.filter(o => o.group === cat.cat)
        arr.push({
          id: cat.id,
          slug: cat.cat,
          name: cat.name,
          image: cat.image,
          tooltip: cat.tooltip,
          description: cat.description,
          pdf_link: cat.pdf_link,
          options: items
        })
      })
      return arr
    })
    function onClickOption (option) {
      if (option.disabled) {
        return
      }
      if (option.type === 'check') {
        store.dispatch('configurator/toggleOption', option)
      }
    }

    function effectiveDiscount (option) {
      if (option.price && option.price.effectiveDiscount > 0) {
        return option.price.effectiveDiscount
      }
      if (option.discount > 0) return Number.parseInt(option.discount)
      const stepDiscount = step.value.discount
      if (stepDiscount > 0) return Number.parseInt(stepDiscount)
      return 0
    }

    function discountedSelfPrice (option) {
      const disc = effectiveDiscount(option)
      return option.price.self * (1 - disc / 100)
    }

    return {
      options,
      step,
      groups,
      checkOptionsGroup,
      onClickOption,
      effectiveDiscount,
      discountedSelfPrice
    }
  }
}
</script>
